<div *ngIf="loginFromLegacy == false" class="flex-content" style="align-items:center;">
    <div [ngStyle]="{'padding-top': (loginSettings.InstanceName.length > 0) ? '30px' : '20px'}">
        <div *ngIf="loginSettings.DistrictLogo != null">
            <a [href]="loginSettings.DistrictURL" target="_blank" aria-label="District Logo">
                <img style="height:80px;" src="data:image/jpg;base64,{{loginSettings.DistrictLogo}}" />
            </a>
        </div>
    </div>

    <label class="districtName" *ngIf="loginSettings.DisplayDistrictNameOnLoginPage"
        [ngStyle]="{'padding-top': (loginSettings.InstanceName.length > 0) ? '30px' : '20px'}">
        {{loginSettings.DistrictName}}
    </label>

    <mat-card>
        <div style="margin-top:5px;margin-left:10px;margin-right:10px;">
            <b style="color:#A20000;text-align:right;line-height:normal;">{{ loginError }}</b>
        </div>
        <tabs *ngIf="loginSettings.DisplaySeparateUserTypes" [tabNames]="tabNames" [startingIndex]="defaultTabIndex"
            (tabChange)="tabChange($event)" [setIndex]="setUserIndex"></tabs>
        <div class="center">
            <div *ngIf="!activateGoogleAuthenticationForStudent || userType!=3" style="width: 100%;">
                <!-- UserName -->
                <tyl-form-field label="Username" style="width:100%"
                    *ngIf="(!loginSettings.ActivateStudent360 && (!loginSettings.V10 || (loginSettings.V10 && !loginSettings.UseUnifiedLoginPage)) || loginSettings.DistrictName == undefined) || (userType==1 && staffGoogleAuthentication)">
                    <input matInput id="txtUserName" aria-label="username disabled" disabled />
                </tyl-form-field>
                <tyl-form-field label="Username" style="width:100%"
                    *ngIf="((loginSettings.ActivateStudent360 || (loginSettings.V10 && loginSettings.UseUnifiedLoginPage)) && loginSettings.DistrictName != undefined) && (userType!=1 || !staffGoogleAuthentication)">
                    <input #userNameRef matInput id="txtUserName" type="text" [(ngModel)]="username" autocomplete="off"
                        aria-label="username" autofocus />
                </tyl-form-field>

                <!-- Password -->
                <tyl-form-field label="Password" style="width:100%"
                    *ngIf="(!loginSettings.ActivateStudent360 && (!loginSettings.V10 || (loginSettings.V10 && !loginSettings.UseUnifiedLoginPage)) || loginSettings.DistrictName == undefined) || (userType==1 && staffGoogleAuthentication)">
                    <input matInput id="txtPassword" aria-label="password disabled" disabled />
                </tyl-form-field>
                <tyl-form-field label="Password" style="width:100%"
                    *ngIf="((loginSettings.ActivateStudent360 || (loginSettings.V10 && loginSettings.UseUnifiedLoginPage)) && loginSettings.DistrictName != undefined) && (userType!=1 || !staffGoogleAuthentication)">
                    <input matInput id="txtPassword" type="password" [(ngModel)]="password" autocomplete="off"
                        aria-label="password" />
                </tyl-form-field>
            </div>
            <div *ngIf="activateGoogleAuthenticationForStudent && userType==3" style="text-align: center;">
                Google Authentication
            </div>

            <div class="buttonRow">
                <div style="min-width:100px;text-align:left;">
                    <tyl-button image="mortarboard button.png" label="360 Login" (clickEvent)="LoginButton360Click();"
                        [noPadding]="true"
                        *ngIf="((loginSettings.ActivateStudent360 && loginSettings.DisplaySeparateUserTypes && userType==1 && !loginSettings.V10) || (loginSettings.V10 && loginSettings.UseUnifiedLoginPage && (loginSettings.ActivateStudent360 || loginSettings.ActivateClassroom360)))">
                    </tyl-button>
                </div>
                <div style="display: flex; flex-direction: column; align-items: center;">
                    <tyl-checkbox
                        *ngIf="!V10 && userType==1 && activateGoogleAuthenticationForStaff && googleError == ''"
                        [(checked)]="staffGoogleAuthentication" (change)="staffGoogleAuthenticationChange()">
                        Use Google Authentication
                    </tyl-checkbox>
                    <button type="button" class="btn btn-link" style="text-decoration: underline; padding-bottom: 10px;"
                        (click)="registerNewFamilyClick(); $event.preventDefault();"
                        [disabled]="!loginSettings.ActivateStudent360" aria-label="Register new family"
                        *ngIf="loginSettings.AllowNewFamiliesToSelfRegister && (loginSettings.V10 || userType==2)">
                        Register New Family
                    </button>
                    <button type="button" class="btn btn-link" style="text-decoration: underline; padding:0px;"
                        (click)="forgotPasswordClick(); $event.preventDefault();"
                        [disabled]="!loginSettings.ActivateStudent360" aria-label="forgot password"
                        *ngIf="loginSettings.ShowForgotPasswordLink && ((loginSettings.StaffUserUseADPassword == false && loginSettings.ActivateGoogleAuthenticationForStaff==false) || userType!=1) && (loginSettings.AllowStudentsToChangeTheirPassword || userType!=3)">
                        Forgot your
                        <span *ngIf="loginSettings.TabSpecificForgotPasswordLink">
                            <span *ngIf="userType==1">staff</span>
                            <span *ngIf="userType==2">parent</span>
                            <span *ngIf="userType==3">student</span>&nbsp;</span>
                        <span *ngIf="loginSettings.TabSpecificForgotPasswordLink">password?</span>
                        <span *ngIf="!loginSettings.TabSpecificForgotPasswordLink">login information?</span>
                    </button>
                    <div style="padding-top: 10px;">
                        <button class="googleButton" *ngIf="!googleError && googleAuthentication && V10" mat-raised-button (click)="googleUserAuthentication(true)">
                            <div style="display: flex; flex-direction: row; align-items: center;">
                                <img style="height: 20px;padding-right: 10px;" src="assets/images/icons/g-logo.png">
                                <span translate>Sign in</span>
                            </div>
                        </button>
                    </div>
                    <div style="padding-top: 10px; color:#A20000" *ngIf="googleError">
                        <div style="display: flex;justify-content: center;">
                            Google Integrations Disabled
                        </div>
                    </div>
                </div>
                <div style="min-width:100px;text-align:right;">
                    <tyl-button image="save.png" [label]="userType==1 && !loginSettings.V10 ? 'Classic Login' : 'Login'"
                        [noPadding]="true" (clickEvent)="LoginButtonClick(false);"
                        *ngIf="loginSettings.DistrictName!=undefined && (loginSettings.ActivateStudent360 || loginSettings.UseUnifiedLoginPage)">
                    </tyl-button>
                    <tyl-button image="save disabled.png" label="Login" [disabled]="true" [noPadding]="true"
                        *ngIf="(!loginSettings.ActivateStudent360 && (!loginSettings.V10 || (loginSettings.V10 && !loginSettings.UseUnifiedLoginPage)) || loginSettings.DistrictName == undefined)">
                    </tyl-button>
                </div>
            </div>
        </div>
    </mat-card>
    <div style="margin-top:10px;text-align:center;font-weight:bold;color:#a20000;"
        *ngIf="!loginSettings.ActivateStudent360 && (!loginSettings.V10 || !loginSettings.UseUnifiedLoginPage)">
        Your district has not activated Tyler SIS Student 360.
        <br />Please wait until you hear from your district that Tyler SIS Student 360 is available before attempting
        to login.
    </div>
    <div style="margin-top:10px;text-align:center;font-weight:bold;color:#a20000;"
        *ngIf="activeDirectoryAddressNotSet && loginSettings.ActivateStudent360">
        Active Directory Agent address is not set!
    </div>
    <tyl-quill-text-only id="divDistrictLoginMessage" [displayBorder]="false"
        [html]="loginSettings.DistrictLoginMessage" placeholder=""></tyl-quill-text-only>
    <div *ngIf="googleError"
        style="display: flex;justify-content: center;color:#A20000; max-width: 75vw;text-align: center;">
        {{googleError}}
    </div>
</div>

<!-- Footer -->
<login-footer *ngIf="loginFromLegacy == false" [userType]="userType"></login-footer>
<!-- Loading Image -->